import { animate, animateChild, group, query, style, transition, trigger } from '@angular/animations'
import type { OnDestroy, OnInit } from '@angular/core'
import { ChangeDetectorRef, Component, HostBinding, inject } from '@angular/core'
import { Subscription } from 'rxjs'

import { ScrollService } from '@app/services/scroll.service'

import { ScrollboxComponent } from '../../../modules/ui/components/scrollbox/scrollbox.component'
import { Closeable } from '../../../overlays/closeable'
import { BreakpointService, BreakpointType } from '../../../services/breakpoint.service'
import { MemberProfileNavComponent } from '../profile-nav/profile-nav.component'

@Component({
  selector: 'sb-member-site-nav',
  templateUrl: './site-nav-container.component.html',
  styleUrls: ['./site-nav-container.component.scss'],
  animations: [
    trigger('animateChildren', [
      transition('* => *', [
        group([
          query('@inOutAnimation', [animateChild()], { optional: false }),
          query('@backdropAnimation', [animateChild()], { optional: false }),
        ]),
      ]),
    ]),
    trigger('backdropAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('0.1s ease-out', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('0.1s ease-out', style({ opacity: 0 }))]),
    ]),
    trigger('inOutAnimation', [
      transition('void => desktop', [
        style({ opacity: 0, transform: 'scale(0.8)' }),
        animate('0.15s ease-out', style({ opacity: 1, transform: 'scale(1)' })),
      ]),
      transition('void => mobile', [
        style({ transform: 'translateX(-100%)' }),
        animate('0.1s linear', style({ transform: 'translateX(0)' })),
      ]),
      transition('desktop => void', [
        style({ opacity: 1, transform: 'scale(1)' }),
        animate('0.15s ease-in', style({ opacity: 0, transform: 'scale(0.8)' })),
      ]),
      transition('mobile => void', [
        style({ transform: 'translateX(0)' }),
        animate('0.1s linear', style({ transform: 'translateX(-100%)' })),
      ]),
    ]),
  ],
  imports: [ScrollboxComponent, MemberProfileNavComponent],
})
export class SiteNavContainerComponent extends Closeable implements OnInit, OnDestroy {
  private readonly breakpointService = inject(BreakpointService)
  private readonly changeDetectorRef = inject(ChangeDetectorRef)
  private readonly scrollService = inject(ScrollService)

  @HostBinding('@animateChildren') hostTrigger = true
  private readonly subscription = new Subscription()
  isMobile = false

  constructor() {
    super()
    this.changeDetectorRef.detach()
  }

  ngOnInit(): void {
    this.subscription.add(
      this.breakpointService.below(BreakpointType.TABLET).subscribe(val => {
        this.isMobile = val
        this.changeDetectorRef.detectChanges()
      }),
    )
    this.subscription.add(this.scrollService.disableBodyScroll$.subscribe())
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
